var _path, _path2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimecardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "timecard-icon",
    d: "M19,22.32H5a2,2,0,0,1-2-2.08V3.76A2,2,0,0,1,5,1.68H19a2,2,0,0,1,2,2.08V20.24A2,2,0,0,1,19,22.32ZM5,2.68A1,1,0,0,0,4,3.76V20.24a1,1,0,0,0,1,1.08H19a1,1,0,0,0,1-1.08V3.76a1,1,0,0,0-1-1.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "timecard-icon",
    d: "M19,22.57H5a2.29,2.29,0,0,1-2.25-2.33V3.75A2.29,2.29,0,0,1,5,1.43H19a2.29,2.29,0,0,1,2.26,2.32V20.24A2.29,2.29,0,0,1,19,22.57ZM5,1.93A1.79,1.79,0,0,0,3.26,3.75V20.24A1.79,1.79,0,0,0,5,22.07H19a1.79,1.79,0,0,0,1.76-1.83V3.75A1.79,1.79,0,0,0,19,1.93ZM19,21.57H5a1.29,1.29,0,0,1-1.25-1.33V3.75A1.29,1.29,0,0,1,5,2.43H19a1.29,1.29,0,0,1,1.26,1.32V20.24A1.29,1.29,0,0,1,19,21.57ZM5,2.93a.79.79,0,0,0-.75.82V20.24a.79.79,0,0,0,.75.83H19a.8.8,0,0,0,.76-.83V3.75A.79.79,0,0,0,19,2.93Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "timecard-icon",
    x: 6.52,
    y: 6.8,
    width: 10.95,
    height: 1.57,
    rx: 0.79
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "timecard-icon",
    x: 6.52,
    y: 11.61,
    width: 10.95,
    height: 1.57,
    rx: 0.79
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "timecard-icon",
    x: 6.52,
    y: 16.42,
    width: 10.95,
    height: 1.57,
    rx: 0.79
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimecardIcon);
export default __webpack_public_path__ + "static/media/timecard_icon.c314c6837f6d4609ad63a435b22be1f0.svg";
export { ForwardRef as ReactComponent };